export default __webpack_public_path__ + "atomic/_patterns/03-organisms/seed-technologies-list/_seed-technologies-list.twig";